import React from "react";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

import "./UpdatedStatutes.scss";

const UpdatedStatutes = () => {
  useDocumentTitle("Statutes with Submitted Updates");
  return (
    <>
      <div className="statutes-header">Statutes with Submitted Updates</div>
      <div className="statutes-container">
        <div className="statutes-container__col1">
          <div style={{ boxShadow: "2px 2px 5px #d9d9d9", padding: "1rem" }}>
            <div style={{ backgroundColor: "#d9d9d9", width: "550px" }}>&nbsp;</div>
            <div style={{ backgroundColor: "#d9d9d9", width: "550px" }}>&nbsp;</div>

            <div className="m-xsmall-top-2" style={{ backgroundColor: "#d9d9d9", width: "300px" }}>
              &nbsp;
            </div>
            <div className="m-xsmall-top-1" style={{ backgroundColor: "#d9d9d9", width: "500px" }}>
              &nbsp;
            </div>
            <div className="m-xsmall-top-1" style={{ backgroundColor: "#d9d9d9", width: "300px" }}>
              &nbsp;
            </div>

            <div className="m-xsmall-top-2" style={{ backgroundColor: "#d9d9d9", width: "300px" }}>
              &nbsp;
            </div>
            <div className="m-xsmall-top-1" style={{ backgroundColor: "#d9d9d9", width: "500px" }}>
              &nbsp;
            </div>
            <div className="m-xsmall-top-1" style={{ backgroundColor: "#d9d9d9", width: "300px" }}>
              &nbsp;
            </div>
            <div className="m-xsmall-top-1" style={{ backgroundColor: "#d9d9d9", width: "300px" }}>
              &nbsp;
            </div>
            <div className="m-xsmall-top-1" style={{ backgroundColor: "#d9d9d9", width: "500px" }}>
              &nbsp;
            </div>
            <div className="m-xsmall-top-1 m-xsmall-bottom-2" style={{ backgroundColor: "#d9d9d9", width: "300px" }}>
              &nbsp;
            </div>
          </div>
        </div>
        <div className="statutes-container__col2">
          <div className="statutes__col2-row1">
            <button className="button primary default medium print-button">Print Document</button>
          </div>
          <div className="statutes__col2-row2">
            <div className="font-secondary m-xsmall-top-1">Select Title</div>
            <div style={{ marginTop: "0.5rem", fontSize: "0.9rem", lineHeight: "1.2rem" }}>
              The selected title will update the Golden Record when the Publish Button is clicked
            </div>

            <select id="format" className="m-xsmall-top-1" style={{ width: "100%" }}>
              <option value="pdf">Title 1</option>
              <option value="xml">Title 2</option>
              <option value="xml">Title 12</option>
            </select>

            <button className="button default primary medium print-button m-xsmall-top-1">
              Publish to Golden Record
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdatedStatutes;
